import * as Sentry from '@sentry/browser';

class UnknownError extends Error {
  constructor(error, { store }) { /* eslint-disable-line */
    super();

    this.name = 'UnknownError';
    this.message = error.message || 'UnknownError';
    this.devMessage = error.message || 'UnknownError';

    Sentry.configureScope((scope) => {
      scope.setLevel('warning');
    });

    Sentry.captureException(error);
  }
}

export default UnknownError;
